(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momentfig-pet-keepsake"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = root => {
    if (!root || root.dataset.petReady) return;
    root.dataset.petReady = '1';
    root.querySelectorAll('[data-pet-thumb]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-pet-slide]').forEach(slide => { slide.hidden = slide.dataset.petSlide !== button.dataset.petThumb; });
      root.querySelectorAll('[data-pet-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    }));
    const form = root.querySelector('form');
    if (!form) return;
    const add = form.querySelector('[data-pet-add]');
    const initialDisabled = add.disabled;
    const initialLabel = add.innerHTML;
    const file = form.querySelector('[data-pet-photo]');
    const preview = form.querySelector('[data-pet-photo-preview]');
    const error = form.querySelector('[data-pet-error]');
    const status = form.querySelector('[data-pet-photo-status]');
    const photoHelp = form.querySelector('.mf-pet__helper');
    const hasHostedUploader = () => Boolean(form.querySelector('#photouploadapp .uploadcare--widget'));
    const syncUploader = () => {
      const hosted = hasHostedUploader();
      if (hosted && photoHelp) {
        const widget = form.querySelector('#photouploadapp .uploadcare--widget');
        if (widget.nextElementSibling !== photoHelp) widget.after(photoHelp);
      }
      if (file.required === hosted) file.required = !hosted;
      if (hosted && !file.disabled) file.disabled = true;
    };
    const uploadObserver = new MutationObserver(syncUploader);
    uploadObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'required'] });
    syncUploader();
    let objectUrl;
    file.addEventListener('invalid', event => {
      event.preventDefault();
      error.textContent = file.validity.valueMissing ? file.dataset.required : file.dataset.error;
      error.hidden = false;
      file.setAttribute('aria-invalid', 'true');
      file.focus();
    });
    file.addEventListener('change', () => {
      file.setCustomValidity(''); error.hidden = true;
      file.removeAttribute('aria-invalid');
      status.textContent = status.dataset.empty;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      preview.hidden = true;
      const selected = file.files[0];
      if (!selected) return;
      if (!['image/jpeg','image/png','image/webp'].includes(selected.type) || selected.size > 10 * 1024 * 1024) {
        file.setCustomValidity(file.dataset.error); file.setAttribute('aria-invalid', 'true'); error.textContent = file.dataset.error; error.hidden = false; return;
      }
      status.textContent = status.dataset.selected;
      objectUrl = URL.createObjectURL(selected); preview.src = objectUrl; preview.hidden = false;
      document.dispatchEvent(new CustomEvent('photo_selected', {detail:{route:'pet-keepsake', product_id:root.dataset.productId}}));
    });
    file.addEventListener('click', () => document.dispatchEvent(new CustomEvent('photo_upload_started', {detail:{route:'pet-keepsake', product_id:root.dataset.productId}})));
    form.addEventListener('submit', event => {
      if (hasHostedUploader() && !Array.from(form.querySelectorAll('input[name^="properties["]')).some(input => !input.name.includes('_MF') && /^https:\/\//.test(input.value))) {
        event.preventDefault();
        error.textContent = file.dataset.required;
        error.hidden = false;
        form.querySelector('.uploadcare--widget__button_type_open')?.focus();
        return;
      }
      if (initialDisabled || !form.reportValidity()) { event.preventDefault(); return; }
      add.disabled = true; add.textContent = add.dataset.adding;
    });
    window.addEventListener('pageshow', () => { add.disabled = initialDisabled; add.innerHTML = initialLabel; });
  };
  document.querySelectorAll('[data-mf-pet]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-mf-pet]')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momentfig-reaction-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-reaction-videos')) {
    customElements.define('mf-reaction-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('.mf-reactions__track');
        this.cards = Array.from(this.querySelectorAll('[data-reaction-card]'));
        this.videos = Array.from(this.querySelectorAll('video'));
        this.previous = this.querySelector('[data-reaction-prev]');
        this.next = this.querySelector('[data-reaction-next]');
        this.current = this.querySelector('[data-reaction-current]');
        this.videos.forEach(video => {
          const play = video.parentElement.querySelector('.mf-reactions__play');
          const cover = video.parentElement.querySelector('.mf-reactions__cover');
          play.addEventListener('click', () => {
            video.play().catch(() => { play.hidden = false; });
          });
          video.addEventListener('play', () => {
            play.hidden = true;
            this.videos.forEach(other => { if (other !== video) other.pause(); });
          });
          video.addEventListener('playing', () => { if (cover) cover.hidden = true; });
          video.addEventListener('ended', () => {
            play.hidden = false;
            if (cover) cover.hidden = false;
          });
          video.addEventListener('error', () => {
            play.hidden = false;
            if (cover) cover.hidden = false;
          });
        });
        this.index = 0;
        this.previous.addEventListener('click', () => this.goTo(this.index - 1));
        this.next.addEventListener('click', () => this.goTo(this.index + 1));
        this.track.addEventListener('scroll', () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !matchMedia('(max-width: 749px)').matches) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        this.update();
      }
      goTo(index) {
        const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
        if (!card) return;
        const left = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
        this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        const left = this.track.getBoundingClientRect().left;
        const index = this.cards.reduce((closest, card, i) =>
          Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[closest].getBoundingClientRect().left - left) ? i : closest, 0);
        if (matchMedia('(max-width: 749px)').matches && index !== this.index) {
          this.videos.forEach((video, i) => { if (i !== index) video.pause(); });
        }
        this.index = index;
        this.current.textContent = String(index + 1);
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.cards.length - 1;
      }
      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.videos.forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
